export const Language_List = [
  { name: "Arabic", code: "ar" },
  { name: "Armenian", code: "hy" },
  { name: "Awadhi", code: "awa" },
  { name: "Azerbaijani", code: "az" },
  { name: "Bashkir", code: "ba" },
  { name: "Basque", code: "eu" },
  { name: "Belarusian", code: "be" },
  { name: "Bengali", code: "bn" },
  { name: "Bhojpuri", code: "bh" },
  { name: "Bosnian", code: "bs" },
  { name: "Brazilian Portuguese", code: "pt-BR" },
  { name: "Bulgarian", code: "bg" },
  { name: "Cantonese (Yue)", code: "yue" },
  { name: "Catalan", code: "ca" },
  { name: "Chhattisgarhi", code: "hne" },
  { name: "Chinese", code: "zh" },
  { name: "Croatian", code: "hr" },
  { name: "Czech", code: "cs" },
  { name: "Danish", code: "da" },
  { name: "Dogri", code: "doi" },
  { name: "Dutch", code: "nl" },
  { name: "English", code: "en" },
  { name: "Estonian", code: "et" },
  { name: "Faroese", code: "fo" },
  { name: "Filipino", code: "fil" },
  { name: "Finnish", code: "fi" },
  { name: "French", code: "fr" },
  { name: "Galician", code: "gl" },
  { name: "Georgian", code: "ka" },
  { name: "German", code: "de" },
  { name: "Greek", code: "el" },
  { name: "Gujarati", code: "gu" },
  { name: "Haryanvi", code: "hry" },
  { name: "Hebrew", code: "he" },
  { name: "Hindi", code: "hi" },
  { name: "Hungarian", code: "hu" },
  { name: "Icelandic", code: "is" },
  { name: "Indonesian", code: "id" },
  { name: "Irish", code: "ga" },
  { name: "Italian", code: "it" },
  { name: "Japanese", code: "ja" },
  { name: "Javanese", code: "jv" },
  { name: "Kannada", code: "kn" },
  { name: "Kashmiri", code: "ks" },
  { name: "Kazakh", code: "kk" },
  { name: "Konkani", code: "kok" },
  { name: "Korean", code: "ko" },
  { name: "Kyrgyz", code: "ky" },
  { name: "Latvian", code: "lv" },
  { name: "Lithuanian", code: "lt" },
  { name: "Macedonian", code: "mk" },
  { name: "Maithili", code: "mai" },
  { name: "Malay", code: "ms" },
  { name: "Maltese", code: "mt" },
  { name: "Mandarin Chinese", code: "cmn" },
  { name: "Marathi", code: "mr" },
  { name: "Marwari", code: "mwr" },
  { name: "Min Nan", code: "nan" },
  { name: "Moldovan", code: "mo" },
  { name: "Mongolian", code: "mn" },
  { name: "Montenegrin", code: "me" },
  { name: "Nepali", code: "ne" },
  { name: "Norwegian", code: "no" },
  { name: "Oriya", code: "or" },
  { name: "Pashto", code: "ps" },
  { name: "Persian (Farsi)", code: "fa" },
  { name: "Polish", code: "pl" },
  { name: "Portuguese", code: "pt" },
  { name: "Punjabi", code: "pa" },
  { name: "Rajasthani", code: "raj" },
  { name: "Romanian", code: "ro" },
  { name: "Russian", code: "ru" },
  { name: "Sanskrit", code: "sa" },
  { name: "Santali", code: "sat" },
  { name: "Serbian", code: "sr" },
  { name: "Sindhi", code: "sd" },
  { name: "Sinhala", code: "si" },
  { name: "Slovak", code: "sk" },
  { name: "Slovene", code: "sl" },
  { name: "Spanish", code: "es" },
  { name: "Swahili", code: "sw" },
  { name: "Swedish", code: "sv" },
  { name: "Tagalog", code: "tl" },
  { name: "Tajik", code: "tg" },
  { name: "Tamil", code: "ta" },
  { name: "Tatar", code: "tt" },
  { name: "Telugu", code: "te" },
  { name: "Thai", code: "th" },
  { name: "Turkish", code: "tr" },
  { name: "Turkmen", code: "tk" },
  { name: "Ukrainian", code: "uk" },
  { name: "Urdu", code: "ur" },
  { name: "Uzbek", code: "uz" },
  { name: "Vietnamese", code: "vi" },
  { name: "Welsh", code: "cy" },
  { name: "Wu", code: "wuu" }
]

export const ELEVENLABS_LANGUAGES = ['en', 'he', 'es', 'fr', 'de', 'it', 'pt', 'pl', 'uk', 'ar', 'zh', 'ja', 'ko', 'hi',
  'nl', 'tr', 'sv', 'id', 'fil', 'ms', 'ro', 'vi', 'cs', 'el', 'bg', 'ru', 'sr', 'hr', 'fi', 'sk', 'da', 'ta', 'no']

export const ELEVENLABS_LANGUAGE_MAP = {}
for (const lang of ELEVENLABS_LANGUAGES) {
  ELEVENLABS_LANGUAGE_MAP[lang] = Language_List.find((l) => l.code === lang)?.name;
  if (!ELEVENLABS_LANGUAGE_MAP[lang]) {
    console.verbose(`Language ${lang} not found in Language_List`);
    delete ELEVENLABS_LANGUAGE_MAP[lang];
  }
}

export const CLOUD_TRANSLATE_LANGUAGES = ['ab', 'ace', 'ach', 'af', 'ak', 'alz', 'am', 'ar', 'as', 'awa', 'ay', 'az',
  'ba', 'ban', 'bbc', 'be', 'bem', 'bew', 'bg', 'bho', 'bik', 'bm', 'bn', 'br', 'bs', 'bts', 'btx', 'bua', 'ca', 'ceb',
  'cgg', 'chm', 'ckb', 'cnh', 'co', 'crh', 'crs', 'cs', 'cv', 'cy', 'da', 'de', 'din', 'doi', 'dov', 'dv', 'dz', 'ee',
  'el', 'en', 'eo', 'es', 'et', 'eu', 'fa', 'ff', 'fi', 'fj', 'fr', 'fr-CA', 'fy', 'ga', 'gaa', 'gd', 'gl', 'gn', 'gom',
  'gu', 'ha', 'haw', 'he', 'hi', 'hil', 'hmn', 'hr', 'hrx', 'ht', 'hu', 'hy', 'id', 'ig', 'ilo', 'is', 'it', 'iw', 'ja',
  'jv', 'jw', 'ka', 'kk', 'km', 'kn', 'ko', 'kri', 'ktu', 'ku', 'ky', 'la', 'lb', 'lg', 'li', 'lij', 'lmo', 'ln', 'lo',
  'lt', 'ltg', 'luo', 'lus', 'lv', 'mai', 'mak', 'mg', 'mi', 'min', 'mk', 'ml', 'mn', 'mni-Mtei', 'mr', 'ms', 'ms-Arab',
  'mt', 'my', 'ne', 'new', 'nl', 'no', 'nr', 'nso', 'nus', 'ny', 'oc', 'om', 'or', 'pa', 'pa-Arab', 'pag', 'pam', 'pap',
  'pl', 'ps', 'pt', 'pt-PT', 'qu', 'rn', 'ro', 'rom', 'ru', 'rw', 'sa', 'scn', 'sd', 'sg', 'shn', 'si', 'sk', 'sl', 'sm',
  'sn', 'so', 'sq', 'sr', 'ss', 'st', 'su', 'sv', 'sw', 'szl', 'ta', 'te', 'tet', 'tg', 'th', 'ti', 'tk', 'tl', 'tn', 'tr',
  'ts', 'tt', 'ug', 'uk', 'ur', 'uz', 'vi', 'xh', 'yi', 'yo', 'yua', 'yue', 'zh', 'zh-CN', 'zh-TW', 'zu'];

export const CLOUD_TRANSLATE_LANGUAGE_MAP = {}
for (const lang of CLOUD_TRANSLATE_LANGUAGES) {
  if (Language_List.find((l) => l.code === lang)) {
    CLOUD_TRANSLATE_LANGUAGE_MAP[lang] = Language_List.find((l) => l.code === lang)?.name;
  }
}

export const ANATOMY_EXPLORER_LANGUAGES = [
  'es', 'he', 'fr', 'de', 'it', 'pt', 'pl', 'uk', 'ar', 'zh', 'ja', 'ko', 'hi',
  'nl', 'tr', 'sv', 'id', 'fil', 'ms', 'ro', 'vi', 'cs', 'el', 'bg', 'ru', 'sr', 
  'hr', 'fi', 'sk', 'da', 'ta', 'no','bn', 'vi', 'ur', 'en'];

export const ANATOMY_EXPLORER_LANGUAGE_MAP = {}
for (const lang of ANATOMY_EXPLORER_LANGUAGES) {
  if (Language_List.find((l) => l.code === lang)) {
    ANATOMY_EXPLORER_LANGUAGE_MAP[lang] = Language_List.find((l) => l.code === lang)?.name;
  }
}

const getLanguageFromModel = (voice) => {
  const lang = {}
  for (const l of voice.verified_languages) {
    if (!lang[l.language]) {
      lang[l.language] = { model_id: l.model_id, sample: l.preview_url };
    }
  }
  return lang;
};
let _voice_list_promise = null;
export const getVoiceList = () => {
  if (_voice_list_promise) {
    return _voice_list_promise;
  }
  _voice_list_promise = new Promise((resolve, reject) => {
    fetch('https://api.elevenlabs.io/v1/voices')
      .then(response => response.json())
      .then((data) => {
        const voices = data.voices.map(voice => {
          return {
            voice_id: voice.voice_id,
            name: voice.name,
            gender: voice.labels.gender,
            language: getLanguageFromModel(voice)
          };

        });
        resolve(voices);
      })
      .catch(error => {
        reject(error);
      });
  });
  return _voice_list_promise;
}